<template>
  <div class="bonuses-view">
    <h4 class="font--h2-2 mb-8">Каталог подарков</h4>

    <div v-if="goods" class="d-flex flex-row flex-wrap" :class="{'justify-center': $vuetify.breakpoint.smAndDown}" style="gap: 24px">
      <bonus-item-card
        v-for="product of goods"
        :key="product.alias"
        v-bind="product"
        :disabled="disableButtonFor === product.alias || product.price > bonus_balance"
        @order="onOrder"
      ></bonus-item-card>
    </div>
    <div v-else class="text-center">
      Нечего отобразить 😢
    </div>

    <v-dialog
      v-model="showPendingResult"
      hide-overlay
      persistent
      min-width="300px"
      max-width="400px"
    >
      <v-card
        :color="pendingResult === false ? 'error' : 'primary'"
        dark
      >
        <template v-if="waitPendingResult">
          <v-card-text>
            Оформление...
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </template>
        <template v-else>
          <v-card-title>
            {{ pendingResult ? 'Заказ успешно оформлен!' : 'Произошла ошибка' }}
          </v-card-title>
          <v-card-text>
            {{ pendingResultText }}
          </v-card-text>
          <v-card-actions>
            <v-spacer />

            <v-btn color="secondary" @click="showPendingResult = false">Закрыть</v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {getGoods as apiGetGoods, orderGood as apiOrderGood} from '@/api/bonuses';

import BonusItemCard from '@/components/common/BonusItemCard.vue';

const imageLoad = (name) => require(`@/assets/img/bonus_${name}.png`)

export default {
  components: {
    BonusItemCard
  },

  data: (vm) => ({
    goods: null,

    disableButtonFor: null,

    waitPendingResult: false,
    pendingResult: null,
    pendingResultText: null,

  }),

  computed: {
    bonus_balance() {
      return this.$store.state.billing.bonus_balance ?? 0;
    },

    showPendingResult: {
      get() {
        return this.waitPendingResult || this.pendingResult != null;
      },

      set(value) {
        this.waitPendingResult = value;
        this.disableButtonFor = this.pendingResultText = this.pendingResult = null;
      }
    },
  },

  async created() {
    await Promise.allSettled([
      this.$store.dispatch('billing/getBalance'),
      apiGetGoods().then((data) => {
        this.goods = Array.isArray(data) ? data.map((item) => ({
          bonus_good_id: item.bonus_good_id,
          alias: item.alias,
          title: item.data.title,
          description: item.data.description,
          price: item.price,
          imagePath: item.data.image ? imageLoad(item.data.image) : null,
        })) : null;
      })
    ])
  },

  methods: {
    async onOrder({ alias, bonus_good_id, price, event }) {
      this.disableButtonFor = alias;

      this.waitPendingResult = true;
      const response = await apiOrderGood(bonus_good_id);
      this.waitPendingResult = false;

      this.pendingResult = Boolean(response);

      if (this.pendingResult) {
        this.pendingResultText = 'Мы свяжемся с вами для уточнения деталей доставки подарка';
        this.$store.commit('billing/setBonusBalance', this.bonus_balance - price);
      } else {
        this.pendingResultText = 'Не удалось оформить. Если это повторяется, то, пожалуйста, обратитесь в тех. поддержку';
      }
    }
  }
};
</script>

<style scoped>
.bonus-item-card {
  width: calc(100% / 3 - 16px);
}
</style>

<style>
.cabinet__card:has(> .bonuses-view) {
  background-color: inherit;
}
</style>
